// src/ApolloClient.js
import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: 'https://rxserver.retvenslabs.com/graphql', // replace with your GraphQL endpoint
  cache: new InMemoryCache()
});

export default client;
